import { render } from "./checkbox-input.vue?vue&type=template&id=686130c0"
import script from "./checkbox-input.vue?vue&type=script&lang=js"
export * from "./checkbox-input.vue?vue&type=script&lang=js"

import "./checkbox-input.vue?vue&type=style&index=0&id=686130c0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__